import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const SitemapPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#05070A] text-white">
      <div className="max-w-6xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="mb-8">
          <a href="/" className="text-blue-400 hover:text-blue-300 transition-colors inline-flex items-center gap-2">
            ← Back to V&V
          </a>
        </div>
        
        <div className="mb-4">
          <span className="text-blue-400 text-xs font-semibold tracking-wider uppercase">Navigation · Site Index</span>
          <h1 className="text-4xl font-bold mt-2 mb-4">Sitemap</h1>
          <p className="text-gray-400 text-lg max-w-2xl">
            Every page on the Vett & Venture platform, organised by audience. Find the right starting point for students, graduates, industrial partners, and the Fix-and-Deliver community.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {/* For Students */}
          <div className="bg-white/5 border border-white/10 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4 pb-3 border-b border-white/10">
              <span className="text-xl">🎓</span>
              <div>
                <div className="text-xs font-semibold tracking-wider text-gray-400 uppercase">For Students</div>
                <div className="w-8 h-0.5 bg-blue-500 mt-1"></div>
              </div>
            </div>
            <ul className="space-y-1">
              <li className="text-xs font-semibold tracking-wider text-gray-500 uppercase pt-2 pb-1">The Forge</li>
              <li><Link to="/forge" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> The Forge — Overview</Link></li>
              <li><Link to="/forge/register" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Apply to The Forge</Link></li>
              <li className="text-xs font-semibold tracking-wider text-gray-500 uppercase pt-2 pb-1">Resources</li>
              <li><Link to="/forge/auth" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Squad Login</Link></li>
              <li><Link to="/forge" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Programme Details</Link></li>
              <li><Link to="/forge/faq" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Student FAQ</Link></li>
            </ul>
          </div>
          
          {/* For Graduates */}
          <div className="bg-white/5 border border-white/10 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4 pb-3 border-b border-white/10">
              <span className="text-xl">🚀</span>
              <div>
                <div className="text-xs font-semibold tracking-wider text-gray-400 uppercase">For Graduates</div>
                <div className="w-8 h-0.5 bg-emerald-500 mt-1"></div>
              </div>
            </div>
            <ul className="space-y-1">
              <li className="text-xs font-semibold tracking-wider text-gray-500 uppercase pt-2 pb-1">Foundry & Venture</li>
              <li><Link to="/dashboard" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Graduate Portal</Link></li>
              <li><Link to="/founder-login" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Founder Login</Link></li>
              <li><Link to="/funding" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Funding Terms</Link></li>
              <li><Link to="/mentorship" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Mentorship</Link></li>
            </ul>
          </div>
          
          {/* For Partners */}
          <div className="bg-white/5 border border-white/10 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4 pb-3 border-b border-white/10">
              <span className="text-xl">🏭</span>
              <div>
                <div className="text-xs font-semibold tracking-wider text-gray-400 uppercase">For Partners</div>
                <div className="w-8 h-0.5 bg-purple-500 mt-1"></div>
              </div>
            </div>
            <ul className="space-y-1">
              <li className="text-xs font-semibold tracking-wider text-gray-500 uppercase pt-2 pb-1">Anchor Companies</li>
              <li><Link to="/company/register" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Register Your Company</Link></li>
              <li><Link to="/company/login" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Company Login</Link></li>
              <li><Link to="/submit-problem" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Submit a Problem</Link></li>
            </ul>
          </div>
          
          {/* The Hub */}
          <div className="bg-white/5 border border-white/10 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4 pb-3 border-b border-white/10">
              <span className="text-xl">🔧</span>
              <div>
                <div className="text-xs font-semibold tracking-wider text-gray-400 uppercase">The Hub</div>
                <div className="w-8 h-0.5 bg-amber-500 mt-1"></div>
              </div>
            </div>
            <ul className="space-y-1">
              <li className="text-xs font-semibold tracking-wider text-gray-500 uppercase pt-2 pb-1">Fix-and-Deliver</li>
              <li><Link to="/submit-problem" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Submit a Problem</Link></li>
              <li><Link to="/fixer/register" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Register as a Fixer</Link></li>
              <li><Link to="/fixer/login" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Fixer Login</Link></li>
            </ul>
          </div>
          
          {/* Company */}
          <div className="bg-white/5 border border-white/10 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4 pb-3 border-b border-white/10">
              <span className="text-xl">🏢</span>
              <div>
                <div className="text-xs font-semibold tracking-wider text-gray-400 uppercase">Company</div>
                <div className="w-8 h-0.5 bg-pink-500 mt-1"></div>
              </div>
            </div>
            <ul className="space-y-1">
              <li className="text-xs font-semibold tracking-wider text-gray-500 uppercase pt-2 pb-1">About V&V</li>
              <li><a href="/" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Home</a></li>
              <li><Link to="/model" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Our Model</Link></li>
              <li><Link to="/case-studies" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Case Studies</Link></li>
            </ul>
          </div>
          
          {/* Legal */}
          <div className="bg-white/5 border border-white/10 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4 pb-3 border-b border-white/10">
              <span className="text-xl">📋</span>
              <div>
                <div className="text-xs font-semibold tracking-wider text-gray-400 uppercase">Legal</div>
                <div className="w-8 h-0.5 bg-gray-500 mt-1"></div>
              </div>
            </div>
            <ul className="space-y-1">
              <li><Link to="/app/privacy" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Privacy Policy</Link></li>
              <li><Link to="/app/terms" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Terms of Use</Link></li>
              <li><Link to="/app/cookies" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Cookie Policy</Link></li>
              <li><Link to="/app/ip-notice" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> IP Notice</Link></li>
              <li><Link to="/app/sitemap" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors py-1.5 px-2 rounded hover:bg-white/5"><span className="text-sm opacity-50">→</span> Sitemap</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SitemapPage;